import script from "./CentralCosts.vue?vue&type=script&setup=true&lang=js"
export * from "./CentralCosts.vue?vue&type=script&setup=true&lang=js"

import "./CentralCosts.vue?vue&type=style&index=0&id=b103b208&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b103b208"]])

export default __exports__